export default interface InvestorInterface {
    id: string;
    email:string;
    updatedDate:string;
    name: string;
  }
  
  const investorInitialValue: InvestorInterface = {
    id: String(),
    email:String(),
    updatedDate: String(),
    name: String(),
  };

  
  export { investorInitialValue };
  